/* eslint-disable import/first */
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Message from './Messages';


var MessageList = function (_Component) {
  _inherits(MessageList, _Component);

  function MessageList() {
    _classCallCheck(this, MessageList);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  MessageList.prototype.componentWillUpdate = function componentWillUpdate() {
    const scrollBottomPoint = this.scrollList.scrollHeight - this.scrollList.clientHeight;
    this.isScrollToBottomOnComponentUpdate = (scrollBottomPoint - this.scrollList.scrollTop < 50);
  };

  MessageList.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.isScrollToBottomOnComponentUpdate){
      this.scrollList.scrollTop = this.scrollList.scrollHeight;
    }
  };

  MessageList.prototype.onScroll = function onScroll(){
    if (this.isScrollTopPosition && this.scrollList.scrollTop > 100){
      this.isScrollTopPosition = false;
    } else if (!this.isScrollTopPosition && this.scrollList.scrollTop <= 100){
      this.isScrollTopPosition = true;
      if (this.props.onScrollToTop) this.props.onScrollToTop();
    }
  }

  MessageList.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: 'sc-message-list', ref: function ref(el) {
          return _this2.scrollList = el;
        }, onScroll: () => this.onScroll()
      },
      this.props.messages.map(function (message, i) {
        return React.createElement(Message, { message: message, key: i });
      })
    );
  };

  return MessageList;
}(Component);

export default MessageList;